import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Consultation Component
 */
let ConsultationComponent = class ConsultationComponent {
    constructor(httpClient, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.consultants = [];
        this.activeTab = 1;
        this.backColor = '';
        this.linkColor = '';
        this.tabColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.setActive(1);
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
    }
    display(id) {
        this.router.navigate(['/consultation', id]);
    }
    setActive(tabId) {
        if (this.activeTab !== tabId) {
            this.activeTab = tabId;
        }
        if (tabId === 1) {
            this.httpClient.get('consulting').subscribe((data) => {
                this.consultants = data;
            });
        }
        else if (tabId === 2) {
            this.httpClient.get('education').subscribe((result) => {
                this.arrayFromServer = Object.values(result);
            }, (error) => {
                console.log(error);
            });
        }
    }
    goToEducation() {
        this.setActive(2);
    }
};
ConsultationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ConsultationComponent = __decorate([
    Component({
        selector: 'ecd-consultation',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./consultation.component.html")).default
    })
], ConsultationComponent);
export { ConsultationComponent };
